class ExpertBioCategories {

    listBioTags: NodeListOf<HTMLElement>;
    lessLink: HTMLElement;
    moreLink: HTMLElement;

    constructor() {
        this.init();
    }

    init() {
        this.lessLink = document.getElementById('aless-bio-cat');
        this.moreLink = document.getElementById('amore-bio-cat');
        this.listBioTags = document.querySelectorAll('.expert-tag-list li');
        if (this.lessLink != null) {
            this.lessLink.addEventListener("click", () => this.ShowlessBioCategory());
        }
        if (this.moreLink != null) {
            this.moreLink.addEventListener("click", () => this.GetMoreBioCategory());
        }
    }

    GetMoreBioCategory() {
        if (this.listBioTags != null) {
            this.listBioTags.forEach(item => {
                item.classList.remove('item-hidden');
            });
            this.moreLink.classList.add("item-hidden");
            this.lessLink.classList.remove("item-hidden");
        }
    }

    ShowlessBioCategory() {
        if (this.lessLink.style.display !== 'none') {
            this.moreLink.classList.remove("item-hidden");
            this.lessLink.classList.add("item-hidden");
            this.listBioTags.forEach((tag, index) => {
                if (index >= 2) {
                    tag.classList.add("item-hidden");
                }
            });
        }
    }
}

export default ExpertBioCategories;